import { render, staticRenderFns } from "./BaseBoxLoader.vue?vue&type=template&id=57f38fd1&"
import script from "./BaseBoxLoader.vue?vue&type=script&lang=js&"
export * from "./BaseBoxLoader.vue?vue&type=script&lang=js&"
import style0 from "./BaseBoxLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports